import { writable } from 'svelte/store';
let localLanguageSetting = localStorage.getItem('language');
let initialLanguage = localLanguageSetting || 'english';
const { subscribe, update } = writable(initialLanguage);
const actions = {
    update: (language) => {
        update(() => language);
        localStorage.setItem('language', language);
    }
};
const language = {
    subscribe,
    ...actions
};
export default language;
